{
  "new-app-version-notification": {
    "buttons": {
      "update": "Update"
    },
    "text": {
      "new-version-available": "New version is available"
    }
  }
}
